import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";

import { logUI } from "../../api/andyliticsApi";

import SchedulingQuestions from './SchedulingQuestions'
import InHomeSchedulingButtons from './InHomeSchedulingButtons'
import AppointmentOverview from './AppointmentOverview';
import RecipientSelect from './RecipientSelect';
import StickyProgressBar from '../common/StickyProgressBar';
import CustomCheckbox from '../common/CustomCheckbox';

const InHomeWho = ({ history, profileList, selectedUsers, getPrefilledData, cancelBooking }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWho.Displayed`, new Date(), Tools.getURLPath());
        populatePreCheckedRecipientSelect();
    }, []);

    const [userList, setUserList] = useState([]);
    const [userAgreed, setUserAgreed] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    const populatePreCheckedRecipientSelect = () => {
        const userList = createUserList();
        if (selectedUsers?.length) {
            selectedUsers.forEach((u) => {
                if (u.isChecked) {
                    userList.forEach(ep => {
                        if (u.mrn === ep.mrn) {
                            ep.isChecked = true;
                        }
                    })
                }
            })
        }
        setUserList(userList);
    }


    const createUserList = () => {
        return profileList.map((prof, i) => {
            let inHomeProfile = {
                patientName: prof.patient?.PatientName,
                firstName: prof.patient?.FirstName,
                lastName: prof.patient?.LastName,
                dob: prof.patient?.DOB,
                mrn: prof.patient?.AMRN,
                eligibleVaccines: [],
                eligible: false,
            }
            let vaxFeature = prof.features.find((feature) => feature.key === "inHomeVaccination")
            if (vaxFeature) {
                inHomeProfile.eligible = true;
                inHomeProfile.eligibleVaccines = vaxFeature.vaccinations;
            }
            return inHomeProfile;
        });
    }

    const handleCheck = (index) => {
        let temp = [...userList];
        temp[index].isChecked = !temp[index].isChecked
        setUserList(temp);
    }

    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWho.Next.Clicked`, new Date(), Tools.getURLPath());
        let selectedUsers = userList.filter((u, i) => {
            return u.isChecked
        })
        if (selectedUsers.length) {
            getPrefilledData(selectedUsers);
            history.push("/inhomeschedule/s2")
        } else {
            setShowWarning(true);
        }

    }

    const onClickCancel = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWho.Cancel.Clicked`, new Date(), Tools.getURLPath());
        cancelBooking();
        history.push("/")
    }
    const anyCheckedUser = userList?.find((user) => {
        return !!user.isChecked
    });
    const disabledNext = !userAgreed || !anyCheckedUser;
    return (
        <>
            <StickyProgressBar className="inhome" widthInPercent={1 / 6 * 100} />
            <div className="container-fluid body-content inhome inhome-scheduling inhome-scheduling-who-container">
                <div className="row">
                    <div className="col-12">
                        <div className="row flex">
                            <div className="in-home-left-panel">
                                <div className="detail-wrapper who-select-detail">
                                    {/* Recipients selection screen*/}
                                    <h1 className="page-heading">Who will be receiving vaccinations?</h1>

                                    <RecipientSelect userList={userList} handleCheck={handleCheck} />
                                    < InHomeSchedulingButtons
                                        disabledNext={disabledNext}
                                        leftBtnLabel='CANCEL' leftOnClick={onClickCancel}
                                        rightOnClick={onClickNext}
                                        showWarning={showWarning}
                                    >
                                       
                                        <div className={'d-flex align-items-start'}>
                                            <CustomCheckbox
                                                isChecked={userAgreed}
                                                disableWrapper={true}
                                                className={'pt-0'}
                                                handleCheck={() => setUserAgreed(!userAgreed)}/>
                                            <div className={`flex-grow-1`}>
                                                <strong>
                                                I understand that a claim will be processed through my insurance.
                                                Self-pay patients are not currently eligible for an in-home vaccine
                                                appointments at this time. if you have questions related to
                                                    payments, please call 833.466.3020
                                                    </strong>
                                            </div>
                                        </div>
                                    </InHomeSchedulingButtons>
                                    <div className="dependants-wrapper">
                                        <span className="d-text">Need to add a family member?
                                            <Link to="/proxyrequestDOB?isFromInHome=true" className="add-dependant-link">
                                                ADD A DEPENDENT
                                            </Link>
                                        </span>
                                        <p className="instruction-text">New family members will need to be approved before they can be scheduled. The approval process can take up to 2 hours.</p>
                                    </div>
                                </div >
                                <SchedulingQuestions />

                            </div >
                            <div className="in-home-right-panel">
                                <AppointmentOverview recipientsPhase={true} />
                            </div>
                        </div >
                    </div >

                </div >
            </div >
        </>
    );
}

const mapStateToProps = state => {
    return {
        profileList: state.memberships.profileList,
        selectedUsers: state.inHome.selectedUsers
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getPrefilledData: (selectedUsers) => {
            dispatch({ type: types.CHECK_GET_INHOME_PREFILL, selectedUsers });
        },
        cancelBooking: () => {
            dispatch({ type: types.CANCEL_INHOME_BOOKING });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWho);